import React, { useContext } from 'react';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { maskBankInfo } from '../../../utils/maskDetails';
import { PETSURE_UNDERWRITER } from '../../../constants/constants';
import { BrandContext } from '../../../contextProviders/brandContext';
import './paymentDetailsPanel.scss';

export const PaymentDetailsPanel = ({ selectedPet }) => {
  const {
    PolicyDetails: {
      BankingInfo: {
        paymentFrequency,
        paymentMethod,
        bsbNumber,
        bank,
        accountNumber,
        accountHolderName,
        cardType,
        cardOwnerName,
        cardNumber,
        cardExpiryDate
      }
    }
  } = selectedPet;

  const {
    activeBrandContext: {
      brand: { partner, partnerPrefix }
    }
  } = useContext(BrandContext);

  const isPartnerUsingLegacyPayment = partner === 'trupanion';

  return (
    <section>
      <span className="labelValueText">
        <em>Payment method</em>
        <strong>{paymentMethod}</strong>
      </span>

      {paymentMethod === 'Direct Debit' && (
        <>
          <span className="labelValueText">
            <em>Account name</em>
            <strong>{accountHolderName}</strong>
          </span>

          <span className="labelValueText">
            <em>BSB</em>
            <strong>
              {selectedPet.Underwriter === PETSURE_UNDERWRITER || isPartnerUsingLegacyPayment
                ? maskBankInfo(bsbNumber)
                : bsbNumber}
            </strong>
          </span>

          <span className="labelValueText">
            <em>Account No.</em>
            <strong>
              {selectedPet.Underwriter === PETSURE_UNDERWRITER || isPartnerUsingLegacyPayment
                ? maskBankInfo(accountNumber)
                : accountNumber}
            </strong>
          </span>
        </>
      )}

      {paymentMethod === 'Credit Card' && (
        <>
          <span className="labelValueText">
            <em>Card owner name</em>
            <strong>{cardOwnerName}</strong>
          </span>

          <span className="labelValueText">
            <em>Card type</em>
            <strong>{cardType}</strong> {/* TODO: Make cute card icons */}
          </span>

          <span className="labelValueText">
            <em>Card number</em>
            <strong>{cardNumber}</strong>
          </span>

          <span className="labelValueText">
            <em>Card expiry date</em>
            <strong>
              {cardExpiryDate.substring(0, 2)}/{cardExpiryDate.substring(2)}
            </strong>
          </span>
        </>
      )}

      <p>
        <strong>Please note: </strong>
        {/* eslint-disable-next-line max-len */}
        If we offer you a subsequent policy, it will be issued on the terms contained in the offer unless you tell us
        otherwise. You should be aware that your authority to debit this account also applies to subsequent policies. If
        the account/card is not yours, you confirm you have the authority of the relevant person to use it and they have
        agreed to these terms.
      </p>
    </section>
  );
};

PaymentDetailsPanel.propTypes = {
  selectedPet: FullPetDetailsPropTypes
};
